<template>
    <b-row class="gox-born" align-h="start" >
        <b-col cols="12" class="pb-6 text-center d-flex justify-content-center align-items-center div-img-born" lg="7">
            <img class="gox-born-imagen" :src="srcImagen" alt="Gox born img" >
            <img class="gox-born-imagen-movil" src="@/assets/images/we/gox2.png" alt="Reunion Gox born img">
        </b-col>
        <b-col cols="12" class="pb-6 gox-born-content-titulo" lg="5">
            <b-row>
                <b-col cols="12" class="mx-auto">
                    <p class="gox-born-titulo col-12 mx-auto" v-html="content.titulo"></p>
                    <p class="gox-born-content col-12 mx-auto" v-html="content.content"></p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
    export default {
        name: 'section-team',
        components: {},
        props: {
            content: Object
        },
        computed: {
            srcImagen() {
                let src = require('@/assets/images/we/' + this.content.imagen)
                return src
            }
        }
    }
</script>
<style scoped>

.gox-born-imagen-movil {
    display: none;
}
@media (max-width: 600px) {
    .gox-born-imagen {
        margin: 0px !important;
        display: none;

    }

    .gox-born-imagen-movil{
        display: flex;

    }
    .div-img-born{
        padding: 0px;
    }

    .gox-born {
        padding: 0px;
    }

    .gox-born-content-titulo{
        padding: 0px;
        margin: 0px;
    }

}


</style>